import './hero2.css';
import React from 'react';

function Hero2() {
    return (
        <div className="Hero">
            <div className="HeroCont">
                <div className="HeroText">
                    <h1>Experience travel different</h1>
                    <p>Your journey starts here. Connect, explore, and share unforgettable experiences.</p>
                </div>
            </div>
            <div className='HeroCont'>
                <div className='HeroText'>
                    <button>
                        get started
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Hero2;
